import React from "react";
import { createContext } from "react";

const initSglContextPropsState = {
  company_id: '',
  company_name: '',
  company_urlpath: '',
  current_user: '',
  is_mobile: false,
  currentTeamId: '',
  userTeams: '',
  verification_status: null,
  pendingVerifyUserAction: null,
  setPendingVerifyUserAction: () => {},
  setVerificationStatus: () => {},
  setCurrentTeamId: () => { },
  setUserTeams: () => { },
  reportToGA: () => { },
  reportToFB: () => { },
  logWPPluginError: () => { },
  logWPPlugin: () => { },
  fetchMyEntriesData: () => { },
  checkLoginOnSGL: () => { },
  loginOnSGL: () => { },
  loginOnSGL2: () => { },
  LogoutSGLSession: () => { },
  getUser: () => { },
  pendingRequestsCount: 0,
  setPendingRequestsCount: () => { },
  refreshPendingRequestsCount: () => { },
  nestApiUrl: '',
  sglApiUrl: '',
  adminDomain: '',
  pendingAgreementsCount: 0, 
  setPendingAgreementsCount: () => { }, 
  refreshPendingAgreementsCount: () => { },
  pendingUserOnboardAction: null,
  setPendingUserOnboardAction: () => {},
  isOnboardingMilestoneEnabled: false,
  setIsOnboardingMilestoneEnabled: () => {},
  checkOnboardingMilestone: () => {}
}
const SglContext = createContext(initSglContextPropsState);
export default SglContext